export default __webpack_public_path__ + "static/media/products.ed6181b7.svg";